import script from "./AnimatedBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedBackground.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedBackground.vue?vue&type=style&index=0&id=429395c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-429395c3"]])

export default __exports__